import { useNavigate } from "react-router";
import "../../components/Template/AccessDenied/AccessDenied.css";
import { FontIcon } from "@fluentui/react";

const NoAccessPage = () => {
  const navigate = useNavigate();
  return (
    <div className="ad-container">
      <div className="ad-header">
        <FontIcon
          iconName="Lock"
          className="icon lock ad-scale"
        />
        <h4 className="ad-title">Access Denied</h4>
      </div>
      <p className="ad-text">You do not have permission to access this site.</p>
      <button
        className="button ad-scale"
        onClick={() => navigate("/")}>
        Return
      </button>
    </div>
  );
};

export default NoAccessPage;
